export default "__VITE_ASSET__Cp$m_o7$__"